import clsx from 'clsx'
import { BuildingFile, SearchFile } from 'types/building'

import LazyThumbnail from 'components/atoms/LazyThumbnail'
import PdfIcon from 'components/icons/PdfIcon'

type Props = {
  file: BuildingFile | SearchFile
  size?: 'large' | 'default' | 'small'
}

export default function PreviewFile({ file, size }: Props) {
  const { extension, thumbnail, name } = file
  if (extension && extension.toLowerCase() === 'pdf') {
    return <PdfIcon size={size} />
  }

  const getDimensions = () => {
    switch (size) {
      case 'large':
        return { w: 120, h: 60 }
      case 'small':
        return { w: 60, h: 40 }
      default:
        return { w: 100, h: 50 }
    }
  }

  const { w, h } = getDimensions()

  return (
    <LazyThumbnail
      name={name}
      url={thumbnail}
      className={clsx('bg-[#021120]', {
        'h-[60px] w-[120px]': size === 'large',
        'h-[50px] w-[100px]': size === 'default',
        'h-[40px] w-[60px]': size === 'small'
      })}
      width={w}
      height={h}
    />
  )
}

PreviewFile.defaultProps = {
  size: 'default'
}
